export function getAccountIDsFromSigners(signers) {
    return signers.map(s => s.getAccountId().toString());
}
